import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearchChoThanhToan } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank";

export const TableDanhSach = ({ dataDanhSach, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchChoThanhToan);
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    dispatch(
      updateDataSearchChoThanhToan({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    onSearch();
  };
  const handlePageSizeChange = (pageSize) => {
    dataSearch.iPageSize = pageSize;
    dataSearch.iPageIndex = 1;
    dispatch(
      updateDataSearchChoThanhToan({
        ...dataSearch,
        iPageSize: pageSize,
        iPageIndex: 1,
      })
    );
    onSearch();
  };
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataDanhSach.iTotal} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="text-center">Mã hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Họ và tên</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">
                      Số tiền cần thanh toán
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Loại thanh toán</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Loại hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="tab-header  text-center">Ngày tạo</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header text-center">Thao tác</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {typeof dataDanhSach.List != "undefined" &&
                    dataDanhSach.List.length > 0 && (
                      <ContentTable
                        dataDanhSach={dataDanhSach}
                        onSearch={onSearch}
                      />
                    )}
                  {typeof dataDanhSach.List === "undefined" ||
                    (dataDanhSach.List.length === 0 && (
                      <div>Không có dữ liệu</div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.iPageIndex}
            pageSize={dataSearch.iPageSize}
            totalCount={dataDanhSach.iTotal}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
